<template>
  <div>
    <div id="formDetail" v-if="viewType == VIEW_FORM_DETAIL">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box box-info">
            <form @submit.prevent class="form-horizontal">
              <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
              <div class="box-body">
                <div class="row">
                  <div class="col-md-2">
                    <div class="q_avatar" @mouseover="showImageControl(true)" @mouseleave="showImageControl(false)">
                      <img :src="formData.imageUrl == '' ? (formData.picture ? formData.picture : '/static/img/placeholder.png') : '/image/Guest/' + formData.imageUrl + '?' + Date.now()" class="img img-responsive" border="1" ref="guestImage">
                      <div class="q_form_image_controls" ref="imageControl">
                        <span class="icon ion-pencil pull-left q_select_file_button" title="Edit" @click="$refs.filePicture.click()"></span>
                        <span class="icon ion-ios-trash-o pull-right q_clear_file_button" title="Clear" @click="clearPicture()"></span>               
                        <div class="q_hidden_input_file ">
                          <input type="file" accept="image/*" ref="filePicture" @change="pictureChange">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-8">                    
                    <div class="form-group">
                      <label for="inputEmail">Email Address</label>
                      <h1 style="margin-top:0px;">
                        <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputEmailAddress" placeholder="Email Address" v-model="formData.emailAddress">
                      </h1>                        
                    </div>                                                                                      
                  </div>                                         
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="nav-tabs-custom">
                      <ul class="nav nav-tabs">
                        <li v-bind:class="{ active: tabActive == TAB_GENERAL }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">General</a></li>
                        <li v-bind:class="{ active: tabActive == TAB_MEMBERSHIP }" v-if="formData.isMember"><a @click="onClickTabMembership()" href="#tab_2" data-toggle="tab" aria-expanded="false">Membership</a></li>
                        <li v-bind:class="{ active: tabActive == TAB_COMMUNICATION }" v-if="viewMode != MODE_CREATE"><a @click="onClickTabCommunication()" href="#tab_3" data-toggle="tab" aria-expanded="true">Communication</a></li>
                        <li v-bind:class="{ active: tabActive == TAB_GROUP }" v-if="viewMode != MODE_CREATE"><a @click="onClickTabGroup()" href="#tab_4" data-toggle="tab" aria-expanded="true">Group</a></li>
                        <li v-bind:class="{ active: tabActive == TAB_PROPERTY }" v-if="viewMode != MODE_CREATE"><a @click="onClickTabProperty()" href="#tab_5" data-toggle="tab" aria-expanded="true">Residence</a></li>
                        <li v-bind:class="{ active: tabActive == TAB_ACTIVITY }" v-if="viewMode != MODE_CREATE"><a @click="onClickTabActivity()" href="#tab_6" data-toggle="tab" aria-expanded="true">Activity</a></li>
                        <li v-bind:class="{ active: tabActive == TAB_DOCUMENT }" v-if="viewMode != MODE_CREATE"><a @click="onClickTabDocument()" href="#tab_7" data-toggle="tab" aria-expanded="true">Documents</a></li>
                        <li v-bind:class="{ active: tabActive == TAB_LEAVE }" v-if="viewMode != MODE_CREATE"><a @click="onClickTabLeave()" href="#tab_8" data-toggle="tab" aria-expanded="true">Leave</a></li>
                      </ul>
                    </div>
                    <div class="tab-content">
                      <div v-bind:class="{ active: tabActive == TAB_GENERAL }" class="tab-pane" id="tab_1">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="inputFirstName" class="col-sm-3 control-label">First Name</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="inputFirstName" placeholder="" v-model="formData.firstName" :disabled="viewMode == MODE_VIEW ? true : false">
                            </div>
                          </div>
                          <div class="form-group" v-if="viewMode != MODE_CREATE">                        
                            <label for="inputMemberNo" class="col-sm-3 control-label">Member No</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" id="inputMemberNo" placeholder="" v-model="formData.memberNo" :disabled="true">
                            </div>                                                            
                            <label class="col-md-1" style="padding-left:0px;">
                              <div v-bind:class="[ { 'icheckbox_flat-green checked': formData.isMember }, { 'icheckbox_flat-green': !formData.isMember }]"
                                  aria-checked="false" aria-disabled="false" style="position: relative;">
                                <input type="checkbox" class="flat-red" checked="" style="position: absolute; opacity: 0;" v-on:click="onCheckMember">
                                <ins class="iCheck-helper" style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
                              </div>
                            </label>                        
                          </div>                                                        
                          <div class="form-group" v-if="viewMode != MODE_CREATE">
                            <label for="inputGuestType" class="col-sm-3 control-label">Guest Type</label>
                            <div class="col-sm-9">
                              <select v-model="formData.guestTypeId" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false">
                                <option v-for="(row, i) in listGuestType" v-bind:key="i" v-bind:value="row.id">
                                  {{ row.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="form-group" v-if="viewMode != MODE_CREATE">
                            <label for="inputBirthPlace" class="col-sm-3 control-label">Birthday</label>
                            <div class="col-sm-6" style="padding-right:0px">
                              <input type="text" class="form-control" id="inputBirthPlace" placeholder="" v-model="formData.birthPlace" :disabled="viewMode == MODE_VIEW ? true : false">
                            </div>
                            <div class="col-sm-3">
                              <div class="input-group">
                                <datepicker v-if="showBirthDate" :readonly="true" name="birthDate" :value=formData.birthDate :format=DATE_FORMAT :input-attr="{ 'id': 'birthDate', 'disabled': viewMode == MODE_VIEW ? true : false }" :input-style="{ 'width': '100%' }"></datepicker>
                                <!-- <span class="input-group-addon">
                                  <i class="icon ion-calendar"></i>
                                </span> -->
                              </div>
                            </div>                              
                          </div>
                          <div class="form-group" v-if="viewMode != MODE_CREATE">
                            <label for="inputGender" class="col-sm-3 control-label">Gender</label>
                            <div class="col-sm-9">
                              <select v-model="formData.genderId" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false">
                                <option v-for="(row, i) in listGender" v-bind:key="i" v-bind:value="row.id">
                                  {{ row.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="form-group" v-if="viewMode != MODE_CREATE">
                            <label for="inputReligion" class="col-sm-3 control-label">Religion</label>
                            <div class="col-sm-9">
                              <select v-model="formData.religionId" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false">
                                <option v-for="(row, i) in listReligion" v-bind:key="i" v-bind:value="row.id">
                                  {{ row.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="form-group" v-if="viewMode != MODE_CREATE">
                            <label for="inputBloodType" class="col-sm-3 control-label">Blood Type</label>
                            <div class="col-sm-9">
                              <select v-model="formData.bloodTypeId" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false">
                                <option v-for="(row, i) in listBloodType" v-bind:key="i" v-bind:value="row.id">
                                  {{ row.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="form-group" v-if="viewMode != MODE_CREATE">
                            <label for="inputPosition" class="col-sm-3 control-label">Position</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="inputPosition" placeholder="" v-model="formData.position" :disabled="viewMode == MODE_VIEW ? true : false">
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="inputLastName" class="col-sm-3 control-label">Last Name</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="inputLastName" placeholder="" v-model="formData.lastName" :disabled="viewMode == MODE_VIEW ? true : false">
                            </div>
                          </div>                            
                          <div class="form-group" v-if="viewMode != MODE_CREATE">
                            <label for="inputMaritalStatus" class="col-sm-3 control-label">Marital Status</label>
                            <div class="col-sm-9">
                              <select v-model="formData.maritalStatusId" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false">
                                <option v-for="(row, i) in listMaritalStatus" v-bind:key="i" v-bind:value="row.id">
                                  {{ row.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="form-group" v-if="viewMode != MODE_CREATE">
                            <label for="inputNPWP" class="col-sm-3 control-label">NPWP</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="inputNPWP" placeholder="" v-model="formData.NPWP" :disabled="viewMode == MODE_VIEW ? true : false">
                            </div>
                          </div>
                          <div class="form-group" v-if="viewMode != MODE_CREATE">
                            <label for="inputKTP" class="col-sm-3 control-label">KTP</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="inputKTP" placeholder="" v-model="formData.KTP" :disabled="viewMode == MODE_VIEW ? true : false">
                            </div>
                          </div>
                          <div class="form-group" v-if="viewMode != MODE_CREATE">
                            <label for="inputSIM" class="col-sm-3 control-label">SIM</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="inputSIM" placeholder="" v-model="formData.SIM" :disabled="viewMode == MODE_VIEW ? true : false">
                            </div>
                          </div>                                                        
                          <div class="form-group" v-if="viewMode != MODE_CREATE">
                            <label for="inputStatus" class="col-sm-3 control-label">Status</label>
                            <div class="col-sm-9">
                              <select v-model="formData.status" class="form-control">
                                <option v-for="(row, i) in listStatus" v-bind:key="i" v-bind:value="row.id">
                                  {{ row.name }}
                                </option>
                              </select>     
                            </div>
                          </div>
                          <div class="form-group" v-if="viewMode == MODE_CREATE">
                            <label for="inputPassword" class="col-sm-3 control-label">Initial Password</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="inputPassword" placeholder="" v-model="formData.password">
                            </div>
                          </div>
                          <div class="form-group" v-if="viewMode != MODE_CREATE">
                            <label for="inputAddress1" class="col-sm-3 control-label">Address 1</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="inputAddress1" placeholder="" v-model="formData.address1" :disabled="viewMode == MODE_VIEW">
                            </div>
                          </div>
                          <div class="form-group" v-if="viewMode != MODE_CREATE">
                            <label for="inputAddress2" class="col-sm-3 control-label">Address 2</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" id="inputAddress2" placeholder="" v-model="formData.address2" :disabled="viewMode == MODE_VIEW">
                            </div>
                          </div>                                                                               
                        </div>
                      </div>
                      <div v-bind:class="{ active: tabActive == TAB_MEMBERSHIP }" class="tab-pane" id="tab_2">
                        <div class="col-md-12">
                          <div class="box no-border">
                            <div class="box-header" style="height:40px;">          
                              <div class="box-tools">              
                                <button @click="onCreateMembership" class="btn btn-primary">Add</button>
                                <button @click="onCreateBacklogMembership" class="btn btn-primary">Add Backlog</button>
                              </div>
                            </div>                              
                            <div class="box-body no-padding table-responsive">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th style="width:10px;text-align:right">#</th>
                                    <th style="text-align:center;">Action</th>
                                    <th style="text-align:left;">Membership</th>
                                    <th style="text-align:center;">Join Date</th>
                                    <th style="text-align:center;">Valid From</th>
                                    <th style="text-align:center;">Valid To</th>
                                    <th style="text-align:right;">Price</th>
                                    <th style="text-align:right;">Tax</th>
                                    <th style="text-align:right;">Discount</th>
                                    <th style="text-align:right;">Amount</th>
                                    <th style="text-align:center;">Currency</th>
                                    <th style="text-align:center;">Status</th>
                                    <th style="text-align:left;">Attachment</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row, i) in listGuestMembership" v-bind:key="i">
                                    <td class="text-nowrap" style="text-align:right;">{{ startSequence + i + 1}}</td>
                                    <td class="text-nowrap" style="text-align:center;">
                                      <a href="#" v-on:click="onDisplayMembership(row)" ref="displayRowMembership" style="padding-right:5px">
                                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                                      </a>
                                      <a href="#" v-on:click="onEditMembership(row)" ref="editRowMembership" style="padding-right:5px">
                                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                                      </a>
                                      <a href="#" v-on:click="onDeleteMembership(row)" ref="deleteRowMembership" style="padding-right:5px">
                                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                                      </a>
                                      <a href="#" v-on:click="onRenewalMembership(row)" ref="renewalRowMembership" style="padding-right:5px">
                                        <span class="icon ion-repeat" data-toggle="tooltip" data-placement="right" title="Renewal"></span>
                                      </a>
                                      <a href="#" v-on:click="onApproveMembership(row)" ref="approveRowMembership" style="padding-right:5px">
                                        <span class="icon ion-checkmark" data-toggle="tooltip" data-placement="right" title="Approve"></span>
                                      </a>
                                      <a href="#" v-on:click="onLeaveMembership(row)" ref="leaveRowMembership" style="padding-right:5px">
                                        <span class="icon ion-ios-pause" data-toggle="tooltip" data-placement="right" title="Create Leave"></span>
                                      </a>
                                    </td>
                                    <td class="text-nowrap" style="text-align:left;">{{ row.membershipName }}</td>
                                    <td style="text-align:center;">{{ row.joinDate }}</td>
                                    <td style="text-align:center;">{{ row.validFrom }}</td>
                                    <td style="text-align:center;">{{ row.validTo }}</td>
                                    <td style="text-align:right;">{{ row.price }}</td>
                                    <td style="text-align:right;">{{ row.tax }}</td>
                                    <td style="text-align:right;">{{ row.discount }}</td>
                                    <td style="text-align:right;">{{ row.amount }}</td>
                                    <td style="text-align:center;">{{ row.currencyName }}</td>
                                    <td style="text-align:center;">
                                      <span v-if="row.status == MEMBERSHIP_SUBMIT" class="badge bg-blue">{{ row.status }}</span>
                                      <span v-if="row.status == MEMBERSHIP_PAID" class="badge bg-yellow">{{ row.status }}</span>
                                      <span v-if="row.status == MEMBERSHIP_ACTIVE" class="badge bg-green">{{ row.status }}</span>
                                      <span v-if="row.status == MEMBERSHIP_EXPIRED" class="badge bg-red">{{ row.status }}</span>
                                    </td>
                                    <!-- <td style="text-align:left;"><a :href="'/image/Guest/MembershipPayment/' + row.attachment">{{ row.attachment }}</a></td> -->
                                    <td style="text-align:left;"><a href="#" @click="getPaymentImage(row.id)">{{ row.attachment }}</a></td>                                     
                                    <td hidden>{{ row.id }}</td>
                                    <td hidden>{{ row.guestId }}</td>
                                    <td hidden>{{ row.membershipId }}</td>
                                    <td hidden>{{ row.currencyId }}</td>
                                    <td hidden>{{ row.period }}</td>
                                    <td hidden>{{ row.freeFlag }}</td>
                                    <td hidden>{{ row.projectId }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-bind:class="{ active: tabActive == TAB_COMMUNICATION }" class="tab-pane" id="tab_3">
                        <div class="col-md-12">
                          <div class="box no-border">
                            <div class="box-header" style="height:40px;">          
                              <div class="box-tools">              
                                <button @click="onCreateCommunication" class="btn btn-primary">Create</button>
                              </div>
                            </div>                              
                            <div class="box-body no-padding table-responsive">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th style="width:10px;text-align:right">#</th>
                                    <th style="text-align:center;">Action</th>
                                    <th style="text-align:left;">Type</th>
                                    <th style="text-align:left;">Contact No.</th>
                                    <th style="text-align:left;">Note</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row, i) in listGuestCommunication" v-bind:key="i">
                                    <td class="text-nowrap" style="text-align:right;">{{ startSequence + i + 1}}</td>
                                    <td class="text-nowrap" style="text-align:center;">
                                      <a href="#" v-on:click="onDisplayCommunication(row)" ref="displayRowCommunication" style="padding-right:5px">
                                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                                      </a>
                                      <a href="#" v-on:click="onEditCommunication(row)" ref="editRowCommunication" style="padding-right:5px">
                                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                                      </a>
                                      <a href="#" v-on:click="onDeleteCommunication(row)" ref="deleteRowCommunication" style="padding-right:5px">
                                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                                      </a>                                                                              
                                    </td>
                                    <td style="text-align:left;">{{ row.type }}</td>
                                    <td style="text-align:left;">{{ row.contactNo }}</td>
                                    <td style="text-align:left;">{{ row.note }}</td>                                     
                                    <td hidden>{{ row.id }}</td>
                                    <td hidden>{{ row.guestId }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-bind:class="{ active: tabActive == TAB_GROUP }" class="tab-pane" id="tab_4">
                        <div class="col-md-12">
                          <div class="box no-border">
                            <div class="box-header" style="height:40px;">          
                              <div class="box-tools">              
                                <button @click="onCreateGroup" class="btn btn-primary">Create</button>
                              </div>
                            </div>
                            <div class="box-body no-padding table-responsive">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th style="width:10px;text-align:right">#</th>
                                    <!-- <th style="text-align:center;">Action</th> -->
                                    <th style="text-align:left;">Group</th>
                                    <th style="text-align:right;">In Quota</th>
                                    <th style="text-align:left;">Relationship</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row, i) in listGuestGroup" v-bind:key="i">
                                    <td class="text-nowrap" style="text-align:right;">{{ startSequence + i + 1}}</td>
                                    <!-- <td class="text-nowrap" style="text-align:center;">
                                      <a href="#" v-on:click="onDisplayGroup(row)" ref="displayRowGroup" style="padding-right:5px">
                                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                                      </a>                                                                             
                                    </td> -->
                                    <td style="text-align:left;">{{ row.groupName }}</td>
                                    <td style="text-align:right;">{{ row.inQuota }}</td>
                                    <td style="text-align:left;">{{ row.relationship }}</td>                                     
                                    <td hidden>{{ row.id }}</td>
                                    <td hidden>{{ row.guestId }}</td>
                                    <td hidden>{{ row.groupId }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>                          
                      </div>
                      <div v-bind:class="{ active: tabActive == TAB_PROPERTY }" class="tab-pane" id="tab_5">
                        <div class="col-md-12">
                          <div class="box no-border">
                            <div class="box-header" style="height:40px;">          
                              <div class="box-tools">              
                                <button @click="onCreateProperty()" class="btn btn-primary">Create</button>
                              </div>
                            </div>                              
                            <div class="box-body no-padding table-responsive">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th style="width:10px;text-align:right">#</th>
                                    <th style="text-align:center;">Action</th>
                                    <th style="text-align:left;">Type</th>
                                    <th style="text-align:left;">Name</th>
                                    <th style="text-align:left;">Cluster</th>
                                    <th style="text-align:left;">Block</th>
                                    <th style="text-align:left;">Unit No.</th>
                                    <th style="text-align:left;">Tower</th>
                                    <th style="text-align:left;">Floor</th>
                                    <th style="text-align:left;">Note</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row, i) in listGuestProperty" v-bind:key="i">
                                    <td class="text-nowrap" style="text-align:right;">{{ startSequence + i + 1}}</td>
                                    <td class="text-nowrap" style="text-align:center;">
                                      <a href="#" v-on:click="onDisplayProperty(row)" style="padding-right:5px">
                                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                                      </a>
                                      <a href="#" v-on:click="onEditProperty(row)" style="padding-right:5px">
                                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                                      </a>
                                      <a href="#" v-on:click="onDeleteProperty(row)" style="padding-right:5px">
                                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                                      </a>                                                                              
                                    </td>
                                    <td style="text-align:left;">{{ row.type }}</td>
                                    <td style="text-align:left;">{{ row.name }}</td>
                                    <td style="text-align:left;">{{ row.cluster }}</td>
                                    <td style="text-align:left;">{{ row.block }}</td>
                                    <td style="text-align:left;">{{ row.number }}</td>
                                    <td style="text-align:left;">{{ row.tower }}</td>
                                    <td style="text-align:left;">{{ row.floor }}</td>
                                    <td style="text-align:left;">{{ row.note }}</td>                                   
                                    <td hidden>{{ row.id }}</td>
                                    <td hidden>{{ row.guestId }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-bind:class="{ active: tabActive == TAB_ACTIVITY }" class="tab-pane" id="tab_6">
                        <div class="col-md-12">
                          <div class="box no-border">                             
                            <div class="box-body no-padding table-responsive">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th style="width:10px;text-align:right">#</th>
                                    <th style="text-align:left;">Name</th>
                                    <th style="text-align:left;">Description</th>
                                    <th style="text-align:center;">Activity Date</th>
                                    <th style="text-align:center;">Activity Time</th>
                                    <th style="text-align:left;">Project</th>
                                    <th style="text-align:left;">Venue</th>
                                    <th style="text-align:left;">Status</th>
                                    <th style="text-align:left;">Attachment</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row, i) in listGuestActivity" v-bind:key="i">
                                    <td class="text-nowrap" style="text-align:right;">{{ startSequence + i + 1}}</td>
                                    <td style="text-align:left;">{{ row.name }}</td>
                                    <td style="text-align:left;">{{ row.description }}</td>
                                    <td style="text-align:center;">{{ row.activityDate }}</td>
                                    <td style="text-align:center;">{{ row.activityTime }}</td>
                                    <td style="text-align:left;">{{ row.projectName }}</td>
                                    <td style="text-align:left;">{{ row.venueName }}</td>
                                    <td style="text-align:left;">{{ row.status }}</td>
                                    <td style="text-align:left;">{{ row.attachment }}</td>                                     
                                    <td hidden>{{ row.id }}</td>
                                    <td hidden>{{ row.guestId }}</td>
                                    <td hidden>{{ row.projectId }}</td>
                                    <td hidden>{{ row.venueId }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>                          
                      </div>
                      <div v-bind:class="{ active: tabActive == TAB_DOCUMENT }" class="tab-pane" id="tab_7">
                        <div class="col-md-12">
                          <div class="box no-border">
                            <div class="box-header" style="height:40px;">          
                              <div class="box-tools">              
                                <button @click="onCreateDocument" class="btn btn-primary">Create</button>
                              </div>
                            </div>                              
                            <div class="box-body no-padding table-responsive">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th style="width:10px;text-align:right">#</th>
                                    <th style="text-align:center;">Action</th>
                                    <th style="text-align:left;">Name</th>
                                    <th style="text-align:left;">Document</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row, i) in listDocument" v-bind:key="i">
                                    <td class="text-nowrap" style="text-align:right;">{{ startSequence + i + 1}}</td>
                                    <td class="text-nowrap" style="text-align:center;">
                                      <a href="#" v-on:click="onDisplayDocument(row)" style="padding-right:5px">
                                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                                      </a>
                                      <a href="#" v-on:click="onEditDocument(row)" style="padding-right:5px">
                                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                                      </a>
                                      <a href="#" v-on:click="onDeleteDocument(row)" style="padding-right:5px">
                                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                                      </a>                                                                             
                                    </td>
                                    <td class="text-nowrap" style="text-align:left;">{{ row.name }}</td>
                                    <td style="text-align:left;"><a href="#" @click="getDocumentImage(row.id)">{{ row.imageUrl }}</a></td>                                     
                                    <td hidden>{{ row.id }}</td>
                                    <td hidden>{{ row.guestId }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>                                              
                      <div v-bind:class="{ active: tabActive == TAB_LEAVE }" class="tab-pane" id="tab_8">
                        <div class="col-md-12">
                          <div class="box no-border">
                            <div class="box-body no-padding table-responsive">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th style="width:10px;text-align:right">#</th>
                                    <th style="text-align:center;">Date From</th>
                                    <th style="text-align:left;">Date To</th>
                                    <th style="text-align:left;">Membership Name</th>
                                    <th style="text-align:left;">Description</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row, i) in listLeave" v-bind:key="i">
                                    <td class="text-nowrap" style="text-align:right;">{{ startSequence + i + 1}}</td>
                                    <td class="text-nowrap" style="text-align:center;">{{ row.dateFrom }}</td>
                                    <td class="text-nowrap" style="text-align:center;">{{ row.dateTo }}</td>
                                    <td class="text-nowrap" style="text-align:left;">{{ row.membershipName }}</td>
                                    <td class="text-nowrap" style="text-align:left;">{{ row.description }}</td>                                
                                    <td hidden>{{ row.id }}</td>
                                    <td hidden>{{ row.guestId }}</td>
                                    <td hidden>{{ row.membershipId }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-footer">
                <div class="box-tools">
                  <button v-on:click="onBack" class="btn btn-default" style="margin-right:10px;">Back</button>
                  <button v-on:click="onCancel" class="btn btn-warning" v-if="viewMode != MODE_VIEW">Cancel</button>
                  <button v-on:click="onSave" class="btn btn-info pull-right" v-if="viewMode != MODE_VIEW">Save</button>
                  <button v-on:click="onEdit" class="btn btn-info pull-right" style="margin-right:10px;" v-if="viewMode == MODE_VIEW">Edit</button>
                </div>
              </div>
            </form>
          </div>          
        </div>
      </div>
    </div>
    <transition name="fade">
      <div id="formMembership" v-if="viewType == VIEW_FORM_MEMBERSHIP">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box box-info">
              <form @submit.prevent class="form-horizontal">
                <input type="hidden" id="inputMembershipId" v-model="formDataMembership.id">
                <input type="hidden" id="inputGuestId" v-model="formDataMembership.guestId">
                <input type="hidden" id="inputMembershipId" v-model="formDataMembership.membershipId">
                <input type="hidden" id="inputCurrencyId" v-model="formDataMembership.currencyId">
                <div class="box-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="inputMembershipName" class="col-sm-4 control-label">Membership</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <input readonly="true" type="text" class="form-control" id="inputMembershipName" v-model="formDataMembership.membershipName">
                            <span class="input-group-btn">
                              <button type="button" class="btn btn-info btn-flat" @click="onSearchMembership" data-toggle="modal" data-target="#modal-default" :disabled="viewMode == MODE_VIEW "><i class="icon ion-fw fa-search"></i></button>
                            </span>
                          </div>
                        </div>                        
                        <!-- <div class="col-sm-8">
                          <input class="form-control" id="inputMembershipName" placeholder="" v-model="formDataMembership.membershipName">
                        </div> -->
                      </div>
                      <div class="form-group" v-if="viewIsGroup">
                        <label for="inputQuota" class="col-sm-4 control-label">Quota Group</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <input type="text" class="form-control" name="quota" @keyup="calculateQuotaGroup($event)" v-model="formDataMembership.quota"
                              :input-attr="{ 'id': 'quota', 'disabled': viewMode == MODE_VIEW ? true : false }">
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputJoinDate" class="col-sm-4 control-label">Join Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" v-if="showJoinDate" :readonly="true" name="joinDate" :value=formDataMembership.joinDate 
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'joinDate', 'disabled': viewMode == MODE_VIEW ? true : false }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedJoinDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputValidFrom" class="col-sm-4 control-label">Valid From</label>
                        <div class="col-sm-8">
                          <!-- <input readonly="true" class="form-control" id="inputValidFrom" placeholder="" v-model="formDataMembership.validFrom"> -->
                          <div class="input-group">
                            <datepicker style="width:100%" v-if="showValidFrom" :readonly="true" name="validFrom" :value=formDataMembership.validFrom 
                                        :format=DATE_FORMAT :input-attr="{ 'id': 'validFrom', 'disabled': true }"
                                        :input-style="{ 'width': '100%' }"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputValidTo" class="col-sm-4 control-label">Valid To</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" v-if="showValidTo" :readonly="true" name="validTo" :value=formDataMembership.validTo
                                        :format=DATE_FORMAT :input-attr="{ 'id': 'validTo', 'disabled': true }"
                                        :input-style="{ 'width': '100%' }"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputPeriod" class="col-sm-4 control-label">Period</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <input readonly="true" type="text" class="form-control" id="inputPeriod" v-model="formDataMembership.period">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="inputPrice" class="col-sm-4 control-label">Price</label>
                        <div class="col-sm-8">
                          <input readonly="true" class="form-control" id="inputPrice" placeholder="" v-model="formDataMembership.price">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputTax" class="col-sm-4 control-label">Tax</label>
                        <div class="col-sm-8">
                          <input readonly="true" class="form-control" id="inputTax" placeholder="" v-model="formDataMembership.tax">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputDiscount" class="col-sm-4 control-label">Discount</label>
                        <div class="col-sm-8">
                          <input readonly="true" class="form-control" id="inputDiscount" placeholder="" v-model="formDataMembership.discount">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputAmount" class="col-sm-4 control-label">Amount</label>
                        <div class="col-sm-4">
                          <input readonly="true" class="form-control" id="inputAmount" placeholder="" v-model="formDataMembership.amount">
                        </div>
                        <div class="col-sm-offset-1 col-sm-3">
                          <div class="checkbox">
                            <label>
                              <input readonly="true" disabled="true" type="checkbox" id="inputFreeFlag" v-model="formDataMembership.freeFlag">Free
                            </label>
                          </div>
                        </div>                        
                      </div>
                      <div class="form-group">
                        <label for="inputCurrency" class="col-sm-4 control-label">Currency</label>
                        <div class="col-sm-8">
                          <input readonly="true" class="form-control" id="inputCurrency" placeholder="" v-model="formDataMembership.currencyName">
                        </div>
                      </div>                                                               
                    </div>
                  </div>
                </div>
                <!-- /.box-body -->
                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBackMembership()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancelMembership()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSaveMembership()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEditMembership(formDataMembership)" class="btn btn-info pull-right">Edit</button>
                  </div>
                </div>
                <!-- /.box-footer -->
              </form>
            </div>          
          </div>
        </div>
      </div>

      <div id="formCommunication" v-if="viewType == VIEW_FORM_COMMUNICATION">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box box-info">
              <form @submit.prevent class="form-horizontal">
                <input type="hidden" id="inputCommunicationId" v-model="formCommunication.id">
                <input type="hidden" id="inputGuestId" v-model="formCommunication.guestId">
                <div class="box-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="inputCommunicationType" class="col-sm-4 control-label">Type</label>
                        <div class="col-sm-8">
                          <select v-model="formCommunication.type" class="form-control" :disabled="viewMode == MODE_VIEW">
                            <option v-for="(row, i) in listCommunicationType" v-bind:key="i" v-bind:value="row.id">
                              {{ row.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputContactNo" class="col-sm-4 control-label">Contact No.</label>
                        <div class="col-sm-8">
                          <input type="text" class="form-control" id="inputContactNo" v-model="formCommunication.contactNo">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputNote" class="col-sm-4 control-label">Note</label>
                        <div class="col-sm-8">
                          <input type="text" class="form-control" id="inputNote" v-model="formCommunication.note">
                        </div>
                      </div>                      
                    </div>
                    <div class="col-md-6">                                                               
                    </div>
                  </div>
                </div>
                <!-- /.box-body -->
                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBackCommunication()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancelCommunication()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSaveCommunication()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEditCommunication(formCommunication)" class="btn btn-info pull-right">Edit</button>
                  </div>
                </div>
                <!-- /.box-footer -->
              </form>
            </div>          
          </div>
        </div>
      </div>

      <div id="formProperty" v-if="viewType == VIEW_FORM_PROPERTY">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box box-info">
              <form @submit.prevent class="form-horizontal">
                <input type="hidden" id="inputPropertyId" v-model="formProperty.id">
                <input type="hidden" id="inputGuestId" v-model="formProperty.guestId">
                <div class="box-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="inputPropertyType" class="col-sm-4 control-label">Type</label>
                        <div class="col-sm-8">
                          <select v-model="formProperty.type" class="form-control" :disabled="viewMode == MODE_VIEW">
                            <option v-for="(row, i) in listPropertyType" v-bind:key="i" v-bind:value="row.id">
                              {{ row.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputName" class="col-sm-4 control-label">Name</label>
                        <div class="col-sm-8">
                          <input type="text" class="form-control" id="inputName" v-model="formProperty.name">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputCluster" class="col-sm-4 control-label">Cluster</label>
                        <div class="col-sm-8">
                          <input type="text" class="form-control" id="inputCluster" v-model="formProperty.cluster">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputBlock" class="col-sm-4 control-label">Block/No.</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="inputBlock" v-model="formProperty.block">                        
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputNumber" class="col-sm-4 control-label">Number</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="inputNumber" v-model="formProperty.number">                        
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputTower" class="col-sm-4 control-label">Tower</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="inputTower" v-model="formProperty.tower">                        
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputFloor" class="col-sm-4 control-label">Floor</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="inputFloor" v-model="formProperty.floor">                        
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputNote" class="col-sm-4 control-label">Note</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="inputNote" v-model="formProperty.note">                        
                        </div>
                      </div>                                                                                                                                    
                    </div>
                    <div class="col-md-6">                                                               
                    </div>
                  </div>
                </div>
                <!-- /.box-body -->
                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBackProperty()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancelProperty()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSaveProperty()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEditProperty(formProperty)" class="btn btn-info pull-right">Edit</button>
                  </div>
                </div>
                <!-- /.box-footer -->
              </form>
            </div>          
          </div>
        </div>
      </div>

      <div id="formDocument" v-if="viewType == VIEW_FORM_DOCUMENT">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box box-info">
              <form @submit.prevent>
                <input type="hidden" id="inputDocumentId" v-model="formDocument.id">
                <input type="hidden" id="inputGuestId" v-model="formDocument.guestId">
                <div class="box-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="inputName" class="col-sm-4 control-label">Name</label>
                        <div class="col-sm-8">
                          <input type="text" class="form-control" id="inputName" v-model="formDocument.name" :disabled="viewMode != MODE_CREATE">
                        </div>
                      </div>                     
                    </div>
                    <div class="col-md-6">                                                               
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="q_avatar" @mouseover="showImageDocumentControl(true)" @mouseleave="showImageDocumentControl(false)">
                        <img :src="formDocument.imageUrl == '' ? (formDocument.picture ? formDocument.picture : '/static/img/placeholder.png') : '/image/Guest/GuestDocument/' + formDocument.imageUrl + '?' + Date.now()" class="img img-responsive" border="1" ref="guestDocumentImage">
                        <div class="q_form_image_controls" ref="imageDocumentControl">
                          <span class="icon ion-pencil pull-left q_select_file_button" title="Edit" @click="$refs.filePictureDocument.click()"></span>
                          <span class="icon ion-ios-trash-o pull-right q_clear_file_button" title="Clear" @click="clearPictureDocument()"></span>               
                          <div class="q_hidden_input_file ">
                            <input type="file" accept="image/*" ref="filePictureDocument" @change="pictureChangeDocument">
                          </div>
                        </div>
                      </div>                     
                    </div>
                    <div class="col-md-6">                                                               
                    </div>
                  </div>                  
                </div>
                <!-- /.box-body -->
                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBackDocument()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancelDocument()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSaveDocument()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEditDocument(formDocument)" class="btn btn-info pull-right">Edit</button>
                  </div>
                </div>
                <!-- /.box-footer -->
              </form>
            </div>          
          </div>
        </div>
      </div>                    

      <div id="formGroup" v-if="viewType == VIEW_FORM_GROUP">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box box-info">
              <form @submit.prevent role="form">
                <input type="hidden" id="inputGrouptId" v-model="formGuestGroup.id">
                <input type="hidden" id="inputGuestId" v-model="formGuestGroup.guestId">
                <div class="box-body">
                  <div class="form-group">
                    <label for="inputName">Name</label>
                    <h1 style="margin-top:0px;">
                      <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Group Name" v-model="formData.name">
                    </h1>                        
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="nav-tabs-custom">
                        <ul class="nav nav-tabs">
                          <li v-bind:class="{ active: tabActive == TAB_GENERAL }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">General</a></li>
                          <li v-bind:class="{ active: tabActive == TAB_GUESTGROUP }"><a @click="onClickTabGuestGroup()" href="#tab_2" data-toggle="tab" aria-expanded="true">Guest of Group</a></li>
                        </ul>
                      </div>
                      <div class="tab-content">
                        <div v-bind:class="{ active: tabActive == TAB_GENERAL }" class="tab-pane" id="tab_1">
                          <div class="box no-border form-horizontal">
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputProductType" class="col-sm-4 control-label">Group Type</label>
                                  <div class="col-sm-8">
                                    <select v-model="formData.type" class="form-control" :disabled="viewMode == MODE_VIEW">
                                      <option v-for="(row, i) in listGroupType" v-bind:key="i" v-bind:value="row.id">
                                        {{ row.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>                                         
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputQuota" class="col-sm-4 control-label">Quota</label>
                                  <div class="col-sm-8">
                                    <input type="text" ref="inputQuota" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputQuota" placeholder="" v-model="formData.quota">
                                  </div>
                                </div>                      
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputCompany" class="col-sm-4 control-label">Company</label>
                                  <div class="col-sm-8">
                                    <input type="text" ref="inputCompany" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputCompany" placeholder="" v-model="formData.company">
                                  </div>
                                </div>                                         
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputMainGuest" class="col-sm-4 control-label">Main Guest</label>
                                  <div class="col-sm-8">
                                    <!-- <select v-model="formData.mainGuestId" class="form-control" :disabled="viewMode == MODE_VIEW" @keyup="onMainGuestKeyUp($event)">
                                      <option v-for="(row, i) in listGuest" v-bind:key="i" v-bind:value="row.id">
                                        {{ row.firstName + ' ' + row.lastName }}
                                      </option>
                                    </select> -->
                                    <input type="text" ref="inputMainGuest" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputMainGuest" v-model="formData.mainGuestName"
                                          list="listMainGuest" @change="onGetMainGuest($event)" @keyup="onSearchMainGuest($event)" placeholder="" >
                                    <datalist id="listMainGuest">
                                      <option v-for="(row, i) in listGuest" :key="i" :value="row.firstName + ' ' + row.lastName"></option>
                                    </datalist>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputNPWP" class="col-sm-4 control-label">NPWP</label>
                                  <div class="col-sm-8">
                                    <input type="text" ref="inputNPWP" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputNPWP" placeholder="" v-model="formData.npwp">
                                  </div>
                                </div>                                         
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputAddress1" class="col-sm-4 control-label">Address 1</label>
                                  <div class="col-sm-8">
                                    <input type="text" ref="inputAddress1" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputAddress1" placeholder="" v-model="formData.address1">
                                  </div>
                                </div>                                 
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">                                        
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="inputAddress2" class="col-sm-4 control-label">Address 2</label>
                                  <div class="col-sm-8">
                                    <input type="text" ref="inputAddress2" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputAddress2" placeholder="" v-model="formData.address2">
                                  </div>
                                </div>                                
                              </div>
                            </div>                                                                                  
                          </div>
                        </div>
                        <div v-bind:class="{ active: tabActive == TAB_GUESTGROUP }" class="tab-pane" id="tab_2">
                          <div class="box no-border">
                            <div class="box-header">         
                              <div class="box-tools">              
                                <button class="btn btn-primary" data-toggle="modal" data-target="#modal-addGuest">Add Guest</button>
                              </div>
                            </div>                                                         
                            <div class="box-body no-padding table-responsive">
                              <table class="table table-striped">
                                <thead>
                                  <tr>
                                    <th style="width:10px;text-align:right">#</th>
                                    <th style="text-align:center;">Action</th>
                                    <th style="text-align:left;">Guest</th>
                                    <th style="text-align:right;">In Quota</th>
                                    <th style="text-align:left;">Relationship</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row, i) in listGuestGroup" v-bind:key="i">
                                    <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                                    <td style="width:85px;text-align:center;">
                                      <a href="#" v-on:click="onDisplayGuestGroup(row)" ref="displayRow" style="padding-right:5px">
                                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                                      </a>
                                      <a href="#" v-on:click="onEditGuestGroup(row)" ref="editRow" style="padding-right:5px">
                                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                                      </a>
                                      <a href="#" v-on:click="onDeleteGuestGroup(row)" ref="deleteRow" style="padding-right:5px">
                                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                                      </a>
                                    </td>                                    
                                    <td style="text-align:left;">{{ row.guestName }}</td>
                                    <td style="text-align:right;">{{ row.inQuota }}</td>
                                    <td style="text-align:left;">{{ row.relationship }}</td>
                                    <td hidden>{{ row.id }}</td>
                                    <td hidden>{{ row.guestId }}</td>
                                    <td hidden>{{ row.groupId }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>                        
                      </div>
                    </div>
                  </div>                                                                     
                  <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
                  <input type="hidden" class="form-control" id="inputMainGuestId" v-model="formData.mainGuestId">
                </div>

                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancel()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button>
                  </div>
                </div>

              </form>
            </div>          
          </div>
        </div>
      </div>       
    </transition>

    <div class="modal fade" id="modal-default" style="display: none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">List of Membership</h4>
          </div>
          <div class="modal-body">
            <div class="box no-border">                             
              <div class="box-body no-padding table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th class="text-nowrap" style="width:10px;text-align:right">#</th>
                      <th class="text-nowrap" style="text-align:center;">Action</th>
                      <th class="text-nowrap" style="text-align:left;">Membership</th>
                      <th class="text-nowrap" style="text-align:left;">Project</th>
                      <th class="text-nowrap" style="text-align:center;">Valid From</th>
                      <th class="text-nowrap" style="text-align:center;">Valid To</th>
                      <th class="text-nowrap" style="text-align:right;">Price</th>
                      <th class="text-nowrap" style="text-align:right;">Tax</th>
                      <th class="text-nowrap" style="text-align:right;">Discount</th>
                      <th class="text-nowrap" style="text-align:center;">Currency</th>
                      <th class="text-nowrap" style="text-align:left;">Period</th>
                      <th class="text-nowrap" style="text-align:center;">Free</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in listMembership" v-bind:key="i">
                      <td class="text-nowrap" style="text-align:right;">{{ startSequence + i + 1}}</td>
                      <td class="text-nowrap" style="text-align:center;">
                        <input class="form-check-input" type="checkbox" v-on:click="onChooseMembershipItem(row, $event)">
                      </td>
                      <td class="text-nowrap" style="text-align:left;">{{ row.name }}</td>
                      <td class="text-nowrap" style="text-align:left;">{{ row.projectName }}</td>
                      <td class="text-nowrap" style="text-align:center;">{{ row.validFrom }}</td>
                      <td class="text-nowrap" style="text-align:center;">{{ row.validTo }}</td>
                      <td class="text-nowrap" style="text-align:right;">{{ row.price }}</td>
                      <td class="text-nowrap" style="text-align:right;">{{ row.tax }}</td>
                      <td class="text-nowrap" style="text-align:right;">{{ row.discount }}</td>
                      <td class="text-nowrap" style="text-align:center;">{{ row.currencyName }}</td>
                      <td class="text-nowrap" style="text-align:left;">{{ row.period }}</td>
                      <td class="text-nowrap" style="text-align:center;">{{ row.freeFlag }}</td>
                      <td hidden>{{ row.id }}</td>
                      <td hidden>{{ row.projectId }}</td>
                      <td hidden>{{ row.typeId }}</td>
                      <td hidden>{{ row.categoryId }}</td>
                      <td hidden>{{ row.currencyId }}</td>                                                                                                                  
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" @click="onChooseMembership($event)">Choose</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modal-create-leave" style="display: none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">Create Leave</h4>
          </div>
          <div class="modal-body">
            <div class="box-body no-border form-horizontal">
              <div class="form-group">
                <label class="col-md-2 control-label">Guest</label>
                <div class="col-md-10">
                    <input type="text" v-model="formLeave.guestName" style="width:100%">
                    <input type="hidden" v-model="formLeave.guestId">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Membership</label>
                <div class="col-md-10">
                    <input type="text" v-model="formLeave.membershipName" style="width:100%">
                    <input type="hidden" v-model="formLeave.membershipId">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Date From</label>
                <div class="col-md-10">
                  <datepicker v-if="showDateFrom" :value=formLeave.dateFrom :format=DATE_FORMAT :input-attr="{ 'id': 'dateFrom' }" :input-style="{ 'width': '100%' }"></datepicker>
                </div>                     
              </div>                                                                                         
              <div class="form-group">
                <label class="col-md-2 control-label">Date To</label>
                <div class="col-md-10">
                  <datepicker v-if="showDateTo" :value=formLeave.dateTo :format=DATE_FORMAT :input-attr="{ 'id': 'dateTo' }" :input-style="{ 'width': '100%' }"></datepicker>
                </div>                     
              </div>

              <div class="form-group">
                <label class="col-md-2 control-label">Description</label>
                <div class="col-md-10">
                    <input type="text" v-model="formLeave.description" style="width:100%">
                </div>                     
              </div>              
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="onContinueCreateLeave($event)">Continue</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
// import datepicker from 'vue-date-picker'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'
import utilities from '../../utilities'
import axios from 'axios'

const VIEW_FORM_DETAIL = 'formDetail'
const VIEW_FORM_REGISTER = 'formRegister'
const VIEW_FORM_MEMBERSHIP = 'formMembership'
const VIEW_FORM_COMMUNICATION = 'formCommunication'
const VIEW_FORM_PROPERTY = 'formProperty'
const VIEW_FORM_DOCUMENT = 'formDocument'
const VIEW_FORM_GROUP = 'formGroup'
const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_GENERAL = 'tabGeneral'
const TAB_MEMBERSHIP = 'tabMembership'
const TAB_COMMUNICATION = 'tabCommunication'
const TAB_GROUP = 'tabGroup'
const TAB_PROPERTY = 'tabProperty'
const TAB_ACTIVITY = 'tabActivity'
const TAB_DOCUMENT = 'tabDocument'
const TAB_LEAVE = 'tabLeave'
const MEMBERSHIP_SUBMIT = 'Submit'
const MEMBERSHIP_PAID = 'Paid'
const MEMBERSHIP_ACTIVE = 'Active'
const MEMBERSHIP_EXPIRED = 'Expired'

export default {
  name: 'GuestForm',
  components: {
    datepicker
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      VIEW_FORM_DETAIL: VIEW_FORM_DETAIL,
      VIEW_FORM_REGISTER: VIEW_FORM_REGISTER,
      VIEW_FORM_MEMBERSHIP: VIEW_FORM_MEMBERSHIP,
      VIEW_FORM_COMMUNICATION: VIEW_FORM_COMMUNICATION,
      VIEW_FORM_PROPERTY: VIEW_FORM_PROPERTY,
      VIEW_FORM_DOCUMENT: VIEW_FORM_DOCUMENT,
      VIEW_FORM_GROUP: VIEW_FORM_GROUP,
      MODE_NONE: MODE_NONE,
      MODE_CREATE: MODE_CREATE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_GENERAL: TAB_GENERAL,
      TAB_MEMBERSHIP: TAB_MEMBERSHIP,
      TAB_COMMUNICATION: TAB_COMMUNICATION,
      TAB_GROUP: TAB_GROUP,
      TAB_PROPERTY: TAB_PROPERTY,
      TAB_ACTIVITY: TAB_ACTIVITY,
      TAB_DOCUMENT: TAB_DOCUMENT,
      TAB_LEAVE: TAB_LEAVE,
      MEMBERSHIP_SUBMIT: MEMBERSHIP_SUBMIT,
      MEMBERSHIP_PAID: MEMBERSHIP_PAID,
      MEMBERSHIP_ACTIVE: MEMBERSHIP_ACTIVE,
      MEMBERSHIP_EXPIRED: MEMBERSHIP_EXPIRED,
      currentStatus: null,
      item: null,
      listData: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      viewType: VIEW_FORM_DETAIL,
      viewMode: MODE_NONE,
      viewIsGroup: false,
      formData: {
        id: 0,
        firstName: '',
        lastName: '',
        emailAddress: '',
        isMember: false,
        memberNo: '',
        imageUrl: '',
        picture: null,
        password: '',
        guestTypeId: '',
        birthDate: '',
        birthPlace: '',
        genderId: '',
        religionId: '',
        bloodTypeId: '',
        maritalStatusId: '',
        NPWP: '',
        KTP: '',
        SIM: '',
        status: 'A',
        address1: '',
        address2: '',
        membership: null
      },
      listGender: null,
      listBloodType: null,
      listGuestType: null,
      listMaritalStatus: null,
      listReligion: null,
      listGuestMembership: null,
      formDataMembership: {
        id: 0,
        guestId: 0,
        membershipId: 0,
        membershipName: 0,
        joinDate: '',
        validFrom: '',
        validTo: '',
        price: '',
        tax: '',
        discount: '',
        amount: '',
        currencyId: 0,
        period: '',
        freeFlag: false,
        status: '',
        attachment: '',
        quota: ''
      },
      tabActive: '',
      listMembership: null,
      listMembershipChoosed: [],
      listCurrency: null,
      listProject: null,
      showBirthDate: false,
      showJoinDate: false,
      showValidFrom: false,
      showValidTo: false,
      listCommunicationType: null,
      listGuestCommunication: null,
      formCommunication: {
        id: 0,
        guestId: 0,
        type: '',
        contactNo: '',
        note: ''
      },
      listGuestGroup: null,
      formGuestGroup: {
        id: 0,
        guestId: 0,
        name: '',
        type: '',
        quota: '',
        mainGuestName: '',
        company: '',
        npwp: '',
        address1: '',
        address2: '',
        mainGuestId: 0
      },
      listPropertyType: null,
      listGuestProperty: null,
      formProperty: {
        id: 0,
        guestId: 0,
        type: '',
        name: '',
        cluster: '',
        block: '',
        number: '',
        tower: '',
        floor: '',
        note: ''
      },
      listGuestActivity: null,
      listDocument: null,
      formDocument: {
        id: 0,
        name: '',
        imageUrl: '',
        picture: null
      },
      backlogMember: false,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'Name',
        WhereClauseByProject: ''
      },
      formLeave: {
        id: 0,
        guestId: 0,
        membershipId: 0,
        projectId: 0,
        dateFrom: '',
        dateTo: '',
        description: ''
      },
      listStatus: [{
        id: 'A',
        name: 'Active'
      },
      {
        id: 'N',
        name: 'Not Active'
      },
      {
        id: 'B',
        name: 'Blocked'
      }],
      showDateFrom: false,
      showDateTo: false,
      listLeave: null
    }
  },
  computed: {
  },
  created() {
    this.formData.id = this.$route.params.callbackId ? this.$route.params.callbackId : this.$route.params.id
    this.viewMode = this.$route.params.mode
    this.callback = this.$route.params.callback

    this.viewType = VIEW_FORM_DETAIL
    this.tabActive = TAB_GENERAL
    this.getDetail()
  },
  mounted() {
  },
  methods: {
    toDataURL(url, callback) {
      var xhr = new XMLHttpRequest()
      xhr.onload = function() {
        var reader = new FileReader()
        reader.onloadend = function() {
          callback(reader.result)
        }
        reader.readAsDataURL(xhr.response)
      }
      xhr.open('GET', url)
      xhr.responseType = 'blob'
      xhr.send()
    },
    getDetail() {
      var me = this
      if (this.formData.id && this.formData.id !== 0) {
        api
          .request('Guest', 'get', '/api/Guest/GetDetail?Id=' + this.formData.id, null)
          .then(response => {
            var data = response.data
            this.formData = data.entity

            this.showBirthDate = false // https://michaelnthiessen.com/force-re-render/#targetText=The%20best%20way%20to%20force,will%20re%2Drender%20the%20component.
            this.$nextTick(() => {
              this.showBirthDate = true
            })
          })
          .then(response => {
            this.getMasterData()
          })
          .then(response => {
            this.toDataURL(me.$refs.guestImage.src, function(dataUrl) {
              me.formData.picture = dataUrl
              me.formData.imageUrl = ''
            })
          })
          .catch(error => {
            var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
            SweetAlert.fire('Error', message, 'error')
          })
      }
    },
    showImageControl(show) {
      if (this.viewMode === MODE_VIEW) {
        return
      }
      let el = this.$refs.imageControl
      el.style.opacity = show ? 0.8 : 0
    },
    pictureChange(e) {
      const image = e.target.files[0]
      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = e => {
        this.formData.picture = e.target.result
        this.$refs.guestImage.src = e.target.result
      }
    },
    clearPicture() {
      this.formData.picture = null
      this.formData.imageUrl = ''
    },
    showImageDocumentControl(show) {
      if (this.viewMode === MODE_VIEW) {
        return
      }
      let el = this.$refs.imageDocumentControl
      el.style.opacity = show ? 0.8 : 0
    },
    pictureChangeDocument(e) {
      const image = e.target.files[0]
      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = e => {
        this.formDocument.picture = e.target.result
        this.$refs.guestDocumentImage.src = e.target.result
      }
    },
    clearPictureDocument() {
      this.formDocument.picture = null
      this.formDocument.imageUrl = ''
    },
    onClickTabDocument() {
      api
        .request('Guest', 'get', '/api/GuestDocument/InquiryByGuestId?GuestId=' + this.formData.id, null)
        .then(response => {
          var resData = response.data
          this.listDocument = resData.entity
          // console.log(this.listDocument)
        })
        .then(response => {
          // this.listDocument.forEach(item => {
          //   this.toDataURL('/image/GuestDocument/' + item.imageUrl, function(dataUrl) {
          //     item.picture = dataUrl
          //     item.imageUrl = ''
          //   })
          // })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      if (this.viewType === VIEW_FORM_REGISTER) {
        this.formData.id = 0
        this.formData.firstName = ''
        this.formData.lastName = ''
        this.formData.emailAddress = ''
        this.formData.password = ''
        this.formData.isMember = false
        this.formData.memberNo = ''
        this.clearPicture()
      } else if (this.viewType === VIEW_FORM_MEMBERSHIP) {
        this.formDataMembership.id = 0
        this.formDataMembership.guestId = 0
        this.formDataMembership.membershipId = 0
        this.formDataMembership.membershipName = ''
        this.formDataMembership.joinDate = ''
        this.formDataMembership.validFrom = ''
        this.formDataMembership.validTo = ''
        this.formDataMembership.price = ''
        this.formDataMembership.tax = ''
        this.formDataMembership.discount = ''
        this.formDataMembership.amount = ''
        this.formDataMembership.currencyId = 0
        this.formDataMembership.currencyName = ''
        this.formDataMembership.period = ''
        this.formDataMembership.freeFlag = false
        this.formDataMembership.quota = 1

        this.showJoinDate = false
        this.$nextTick(() => {
          this.showJoinDate = true
        })
        this.showValidFrom = false
        this.$nextTick(() => {
          this.showValidFrom = true
        })
        this.showValidTo = false
        this.$nextTick(() => {
          this.showValidTo = true
        })
      } else if (this.viewType === VIEW_FORM_COMMUNICATION) {
        this.formCommunication.id = 0
        this.formCommunication.guestId = 0
        this.formCommunication.type = ''
        this.formCommunication.contactNo = ''
        this.formCommunication.note = ''
      } else if (this.viewType === VIEW_FORM_PROPERTY) {
        this.formProperty.id = 0
        this.formCommunication.guestId = 0
        this.formProperty.type = ''
        this.formProperty.name = ''
        this.formProperty.cluster = ''
        this.formProperty.block = ''
        this.formProperty.number = ''
        this.formProperty.tower = ''
        this.formProperty.floor = ''
        this.formProperty.note = ''
      }
    },
    getPaymentImageUrl(id) {
      return api.getBaseUrl('Guest', '/api/Guest/GetImagePayment?Id=' + id)
    },
    getDocumentImageUrl(id) {
      return api.getBaseUrl('Guest', '/api/GuestDocument/GetImageDocument?Id=' + id)
    },
    onActivity(id) {
      alert('Activity ID: ' + id)
    },
    onDetail(id) {
      this.viewType = VIEW_FORM_DETAIL
      this.viewMode = MODE_VIEW
      this.tabActive = TAB_GENERAL
      this.getMasterData()
      api
        .request('Guest', 'get', '/api/Guest/GetDetail?Id=' + id, null)
        .then(response => {
          var data = response.data
          this.formData.id = data.entity.id
          this.formData.firstName = data.entity.firstName
          this.formData.lastName = data.entity.lastName
          this.formData.emailAddress = data.entity.emailAddress
          this.formData.isMember = data.entity.isMember
          this.formData.memberNo = data.entity.memberNo
          this.formData.imageUrl = data.entity.imageUrl
          this.formData.picture = data.entity.picture
          this.formData.guestTypeId = data.entity.guestTypeId
          this.formData.birthDate = data.entity.birthDate
          this.formData.birthPlace = data.entity.birthPlace
          this.formData.genderId = data.entity.genderId
          this.formData.religionId = data.entity.religionId
          this.formData.bloodTypeId = data.entity.bloodTypeId
          this.formData.maritalStatusId = data.entity.maritalStatusId
          this.formData.NPWP = data.entity.npwp
          this.formData.KTP = data.entity.ktp
          this.formData.SIM = data.entity.sim
          this.formData.status = data.entity.status

          this.showBirthDate = false // https://michaelnthiessen.com/force-re-render/#targetText=The%20best%20way%20to%20force,will%20re%2Drender%20the%20component.
          this.$nextTick(() => {
            this.showBirthDate = true
          })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getMasterData() {
      api
        .request('Guest', 'get', '/api/Gender/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listGender = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })

      api
        .request('Guest', 'get', '/api/BloodType/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listBloodType = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })

      api
        .request('Guest', 'get', '/api/GuestType/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listGuestType = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })

      api
        .request('Guest', 'get', '/api/MaritalStatus/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listMaritalStatus = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })

      api
        .request('Guest', 'get', '/api/Religion/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listReligion = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      this.$router.push({ name: this.callback })
    },
    onSave() {
      var method = ''
      var reqData = null
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Register'
          reqData = {
            Id: this.formData.id,
            EmailAddress: this.formData.emailAddress,
            FirstName: this.formData.firstName,
            LastName: this.formData.lastName,
            Position: this.formData.position,
            IsMember: false,
            MemberNo: '',
            ImageBase64String: this.formData.picture,
            Password: this.formData.password,
            GuestTypeId: 1,
            GenderId: 1,
            ReligionId: 1,
            BloodTypeId: 1,
            MaritalStatusId: 1
          }
          break
        case MODE_UPDATE:
          method = 'Update'
          reqData = {
            Id: this.formData.id,
            FirstName: this.formData.firstName,
            LastName: this.formData.lastName,
            EmailAddress: this.formData.emailAddress,
            IsMember: this.formData.isMember,
            MemberNo: this.formData.memberNo,
            Position: this.formData.position,
            ImageUrl: this.formData.imageUrl,
            ImageBase64String: this.formData.picture,
            GuestTypeId: this.formData.guestTypeId,
            BirthDate: $('#birthDate').val(), // this.formData.birthDate,
            BirthPlace: this.formData.birthPlace,
            GenderId: this.formData.genderId,
            ReligionId: this.formData.religionId,
            BloodTypeId: this.formData.bloodTypeId,
            MaritalStatusId: this.formData.maritalStatusId,
            NPWP: this.formData.NPWP,
            KTP: this.formData.KTP,
            SIM: this.formData.SIM,
            Status: this.formData.status,
            Address1: this.formData.address1,
            Address2: this.formData.address2
          }
          break
      }

      let isSuccess = false
      api
        .request('Guest', 'post', '/api/Guest/' + method, reqData)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity
          isSuccess = resData.returnStatus
          var status = resData.returnStatus ? 'success' : 'error'
          var message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
        })
        .then(response => {
          if (isSuccess) {
            this.viewType = VIEW_FORM_DETAIL
            this.viewMode = MODE_VIEW
          }
        })
        .then(response => {
          if (isSuccess) {
            this.saveDocument()
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    saveDocument() {
      // var reqData = {
      //   GuestId: this.formData.id,
      //   ImageBase64String: this.formDocument.picture
      // }
    },
    onEdit() {
      this.viewType = VIEW_FORM_DETAIL
      this.viewMode = MODE_UPDATE
    },
    onCheckMember() {
      if (this.viewMode === MODE_UPDATE) {
        this.formData.isMember = !this.formData.isMember
      }
    },
    onClickTabMembership() {
      this.inquiryAllCurrency()
      api
        .request('Guest', 'get', '/api/Guest/GetMembership?GuestId=' + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.listGuestMembership = data.entity

          var currencyName
          this.listGuestMembership.forEach(itemGuestMembership => {
            currencyName = ''
            this.listCurrency.some(function(itemCurrency, index) {
              if (itemGuestMembership.currencyId === itemCurrency.id) {
                currencyName = itemCurrency.name
              }
            })
            itemGuestMembership.currencyName = currencyName
          })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onCreateMembership() {
      this.viewType = VIEW_FORM_MEMBERSHIP
      this.viewMode = MODE_CREATE
      this.backlogMember = false
      this.formDataMembership.guestId = this.formData.id
      this.formDataMembership.membershipName = ''

      this.showJoinDate = false
      this.$nextTick(() => {
        this.showJoinDate = true
      })
      this.showValidFrom = false
      this.$nextTick(() => {
        this.showValidFrom = true
      })
      this.showValidTo = false
      this.$nextTick(() => {
        this.showValidTo = true
      })
    },
    onCreateBacklogMembership() {
      this.viewType = VIEW_FORM_MEMBERSHIP
      this.viewMode = MODE_CREATE
      this.backlogMember = true
      this.formDataMembership.guestId = this.formData.id
      this.formDataMembership.membershipName = ''

      this.showJoinDate = false
      this.$nextTick(() => {
        this.showJoinDate = true
      })
      this.showValidFrom = false
      this.$nextTick(() => {
        this.showValidFrom = true
      })
      this.showValidTo = false
      this.$nextTick(() => {
        this.showValidTo = true
      })
    },
    onDisplayMembership(row) {
      this.viewType = VIEW_FORM_MEMBERSHIP
      this.viewMode = MODE_VIEW

      this.formDataMembership.id = row.id
      this.formDataMembership.guestId = row.guestId
      this.formDataMembership.membershipId = row.membershipId
      this.formDataMembership.membershipName = row.membershipName
      this.formDataMembership.joinDate = row.joinDate
      this.formDataMembership.validFrom = row.validFrom
      this.formDataMembership.validTo = row.validTo
      this.formDataMembership.price = row.price
      this.formDataMembership.tax = row.tax
      this.formDataMembership.discount = row.discount
      this.formDataMembership.amount = row.amount
      this.formDataMembership.currencyId = row.currencyId
      this.formDataMembership.currencyName = row.currencyName
      this.formDataMembership.period = row.period
      this.formDataMembership.freeFlag = row.freeFlag === 'true'
      this.formDataMembership.quota = row.quota

      this.showJoinDate = false
      this.$nextTick(() => {
        this.showJoinDate = true
      })
      this.showValidFrom = false
      this.$nextTick(() => {
        this.showValidFrom = true
      })
      this.showValidTo = false
      this.$nextTick(() => {
        this.showValidTo = true
      })
    },
    onEditMembership(row) {
      this.viewType = VIEW_FORM_MEMBERSHIP
      this.viewMode = MODE_UPDATE

      this.formDataMembership.id = row.id
      this.formDataMembership.guestId = row.guestId
      this.formDataMembership.membershipId = row.membershipId
      this.formDataMembership.membershipName = row.membershipName
      this.formDataMembership.joinDate = row.joinDate
      this.formDataMembership.validFrom = row.validFrom
      this.formDataMembership.validTo = row.validTo
      this.formDataMembership.price = row.price
      this.formDataMembership.tax = row.tax
      this.formDataMembership.discount = row.discount
      this.formDataMembership.amount = row.amount
      this.formDataMembership.currencyId = row.currencyId
      this.formDataMembership.currencyName = row.currencyName
      this.formDataMembership.period = row.period
      this.formDataMembership.freeFlag = row.freeFlag === 'true'
      this.formDataMembership.quota = row.quota

      this.showJoinDate = false
      this.$nextTick(() => {
        this.showJoinDate = true
      })
      this.showValidFrom = false
      this.$nextTick(() => {
        this.showValidFrom = true
      })
      this.showValidTo = false
      this.$nextTick(() => {
        this.showValidTo = true
      })
    },
    onCancelMembership() {
      if (this.viewMode === MODE_CREATE) {
        this.initForm()
      } else if (this.viewMode === MODE_UPDATE) {
        this.onDisplayMembership(this.formDataMembership)
      }
    },
    onBackMembership() {
      this.initForm()
      this.viewType = VIEW_FORM_DETAIL
      this.viewMode = MODE_VIEW
      this.tabActive = TAB_MEMBERSHIP
      this.onClickTabMembership()
    },
    onRenewalMembership(row) {
      this.viewType = VIEW_FORM_MEMBERSHIP
      this.viewMode = MODE_VIEW

      this.formDataMembership.id = 0
      this.formDataMembership.guestId = row.guestId
      this.formDataMembership.membershipId = row.membershipId
      this.formDataMembership.membershipName = row.membershipName
      this.formDataMembership.joinDate = row.joinDate
      this.formDataMembership.validFrom = row.validFrom
      this.formDataMembership.validTo = row.validTo
      this.formDataMembership.price = row.price
      this.formDataMembership.tax = row.tax
      this.formDataMembership.discount = row.discount
      this.formDataMembership.amount = row.amount
      this.formDataMembership.currencyId = row.currencyId
      this.formDataMembership.currencyName = row.currencyName
      this.formDataMembership.period = row.period
      this.formDataMembership.freeFlag = row.freeFlag === 'true'
      this.formDataMembership.quota = row.quota

      this.showJoinDate = false
      this.$nextTick(() => {
        this.showJoinDate = true
      })
      this.showValidFrom = false
      this.$nextTick(() => {
        this.showValidFrom = true
      })
      this.showValidTo = false
      this.$nextTick(() => {
        this.showValidTo = true
      })
    },
    onApproveMembership(row) {
      SweetAlert.fire({
        title: 'Are you sure to approve this membership ?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continue',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.approveMembership(row)
          SweetAlert.fire('Membership Approval', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          SweetAlert.fire('Cancelled', 'Membership approval was cancelled', 'info')
        }
      })
    },
    approveMembership(row) {
      const requestMembership = api.request('Guest', 'get', '/api/Membership/Inquiry?WhereClause=Id=' + row.membershipId + '&PageSize=999&CurrentPageNumber=1&SortDirection=ASC&SortExpression=Id', null)
      const requestProject = api.request('Account', 'get', '/api/Project/InquiryAll', null)
      const requestCompany = api.request('Account', 'get', '/api/Company/InquiryAll', null)

      axios
        .all([requestMembership, requestProject, requestCompany])
        .then(
          axios.spread((...response) => {
            const responseMembership = response[0]
            const responseProject = response[1]
            const responseCompany = response[2]

            if (responseMembership.data.returnStatus && responseProject.data.returnStatus && responseCompany.data.returnStatus) {
              let project = responseProject.data.entity.find(x => x.id === responseMembership.data.entity[0].projectId)
              let company = responseCompany.data.entity.find(x => x.id === project.companyId)

              let reqData = {
                Id: row.id,
                GuestId: row.guestId,
                MembershipId: row.membershipId,
                MembershipName: row.membershipName,
                JoinDate: row.joinDate,
                ValidFrom: row.validFrom,
                ValidTo: row.validTo,
                Price: row.price,
                Tax: row.tax,
                Discount: row.discount,
                Amount: row.amount,
                CurrencyId: row.currencyId,
                CurrencyName: row.currencyName,
                Period: row.period,
                FreeFlag: row.freeFlag,
                Status: row.status,
                Attachment: row.attachment,
                ProjectId: row.projectId,
                ProjectName: row.projectName,
                BusinessAreaSAP: project.businessArea,
                CompanyCodeSAP: company.sapCode
              }

              let status = 'success'
              let message = ''
              api
                .request('Guest', 'post', '/api/Guest/ApprovePayMembership', reqData)
                .then(response => {
                  var resData = response.data
                  status = resData.returnStatus ? 'success' : 'error'
                  message = resData.returnMessage.join('<br>')

                  SweetAlert.fire(status, message, status)

                  this.onClickTabMembership()
                })
                .catch(error => {
                  var message = error.message
                  SweetAlert.fire('Error', message, 'error')
                })
            } else {
              let message = responseProject.data.returnMessage.join('<br>') + '<br>' + responseCompany.data.returnMessage.join('<br>')
              SweetAlert.fire('Error', message, 'error')
            }
          })
        )
        .catch(error => {
          SweetAlert.fire('Error', error.message, 'error')
        })
    },
    onSaveMembership() {
      var url = ''
      url = this.backlogMember === true ? '/api/Guest/CreateBacklogMembershipDetail' : '/api/Guest/CreateMembershipDetail'

      var reqData = {
        Id: this.formDataMembership.id,
        GuestId: this.formDataMembership.guestId,
        MembershipId: this.formDataMembership.membershipId,
        MembershipName: this.formDataMembership.membershipName,
        JoinDate: this.formDataMembership.joinDate,
        ValidFrom: this.formDataMembership.validFrom,
        ValidTo: this.formDataMembership.validTo,
        Price: this.formDataMembership.price,
        Tax: this.formDataMembership.tax,
        Discount: this.formDataMembership.discount,
        Amount: this.formDataMembership.amount,
        CurrencyId: this.formDataMembership.currencyId,
        CurrencyName: this.formDataMembership.currencyName,
        Period: this.formDataMembership.period,
        FreeFlag: this.formDataMembership.freeFlag,
        QuotaGroup: this.formDataMembership.quota === '' ? 1 : this.formDataMembership.quota
      }

      var status = 'success'
      var message = ''
      api
        .request('Guest', 'post', url, reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')

          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.viewMode = MODE_VIEW
            this.viewType = VIEW_FORM_MEMBERSHIP
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    inquiryAllCurrency() {
      api
        .request('Account', 'get', '/api/Currency/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listCurrency = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    inquiryAllProject() {
      api
        .request('Account', 'get', '/api/Project/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listProject = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onSearchMembership() {
      this.inquiryAllCurrency()
      this.inquiryAllProject()

      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      api
        .request('Guest', 'get', '/api/Membership/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + '&CurrentPageNumber=1&PageSize=9999999', null)
        .then(response => {
          var data = response.data
          this.listMembership = data.entity

          var currencyName, projectName
          this.listMembership.forEach(item => {
            currencyName = ''
            this.listCurrency.some(function(itemCurrency, index) {
              if (item.currencyId === itemCurrency.id) {
                currencyName = itemCurrency.name
              }
            })
            item.currencyName = currencyName

            projectName = ''
            this.listProject.some(function(itemProject, index) {
              if (item.projectId === itemProject.id) {
                projectName = itemProject.name
              }
            })
            item.projectName = projectName
          })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onChooseMembershipItem(row, event) {
      var arrMemberships = this.listMembershipChoosed

      if (event.target.checked) {
        arrMemberships.push(row)
        var arrMembershipUnique = arrMemberships.filter(function(item, index) {
          return arrMemberships.indexOf(item) >= index
        })
        arrMemberships = arrMembershipUnique
      } else {
        for (var i = 0; i < arrMemberships.length; i++) {
          if (arrMemberships[i].id === row.id) {
            arrMemberships.splice(i, 1)
          }
        }
      }

      this.listMembershipChoosed = arrMemberships
    },
    onChooseMembership(event) {
      if (this.listMembershipChoosed.length === 0) {
        SweetAlert.fire('Warning', 'Please choose one item', 'warning')
      } else if (this.listMembershipChoosed.length > 1) {
        SweetAlert.fire('Warning', 'Please choose only one item', 'warning')
      } else {
        this.formDataMembership.id = 0
        this.formDataMembership.guestId = this.formData.id
        this.formDataMembership.membershipId = this.listMembershipChoosed[0].id
        this.formDataMembership.membershipName = this.listMembershipChoosed[0].name
        this.formDataMembership.price = this.listMembershipChoosed[0].price
        this.formDataMembership.tax = this.listMembershipChoosed[0].tax
        this.formDataMembership.discount = this.listMembershipChoosed[0].discount
        this.formDataMembership.freeFlag = this.listMembershipChoosed[0].freeFlag
        this.viewIsGroup = this.listMembershipChoosed[0].isGroup

        if (this.formDataMembership.freeFlag) {
          this.formDataMembership.amount = 0
        } else {
          this.formDataMembership.amount = utilities.DisplayNumber(
            (utilities.ParseNumber(this.formDataMembership.tax) + 100) / 100 * utilities.ParseNumber(this.formDataMembership.price) - utilities.ParseNumber(this.formDataMembership.discount)
            )
        }
        this.formDataMembership.currencyId = this.listMembershipChoosed[0].currencyId

        var currencyName = ''
        var currencyId = this.formDataMembership.currencyId
        this.listCurrency.some(function(itemCurrency, index) {
          if (currencyId === itemCurrency.id) {
            currencyName = itemCurrency.name
          }
        })

        this.formDataMembership.currencyName = currencyName
        this.formDataMembership.period = this.listMembershipChoosed[0].period

        if (this.formDataMembership.validFrom) {
          this.calculateValidTo(this.formDataMembership.validFrom)
          this.showValidTo = false
          this.$nextTick(() => {
            this.showValidTo = true
          })
        }

        this.$refs.btnCloseModal.click()
      }
    },
    calculateValidTo(date) {
      var validFrom = utilities.ParseDate(date, this.DATE_FORMAT)
      var validTo = null
      switch (this.formDataMembership.period) {
        case 'Annual':
          validTo = new Date(validFrom.setFullYear(validFrom.getFullYear() + 1))
          break
        case 'Half Yearly':
          validTo = new Date(validFrom.setMonth(validFrom.getMonth() + 6))
          break
        case 'Monthly':
          validTo = new Date(validFrom.setMonth(validFrom.getMonth() + 1))
          break
        default:
          break
      }
      this.formDataMembership.validTo = utilities.DisplayDate(validTo, 'dd.MM.yyyy')
    },
    calculateQuotaGroup(event) {
      if (this.formDataMembership.freeFlag) {
        this.formDataMembership.amount = 0
      } else {
        this.formDataMembership.amount = utilities.DisplayNumber(
          ((utilities.ParseNumber(this.formDataMembership.tax) + 100) / 100 * utilities.ParseNumber(this.formDataMembership.price) - utilities.ParseNumber(this.formDataMembership.discount)) * utilities.ParseNumber(this.formDataMembership.quota))
      }
    },
    onPickedJoinDate(date) {
      this.formDataMembership.joinDate = date
      this.formDataMembership.validFrom = date
      this.calculateValidTo(this.formDataMembership.validFrom)

      this.showValidFrom = false
      this.$nextTick(() => {
        this.showValidFrom = true
      })
      this.showValidTo = false
      this.$nextTick(() => {
        this.showValidTo = true
      })
    },
    onClickTabCommunication() {
      api
        .request('Guest', 'get', '/api/GuestCommunication/InquiryByGuestId?GuestId=' + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.listGuestCommunication = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })

      api
        .request('Guest', 'get', '/api/GuestCommunication/GetCommunicationType', null)
        .then(response => {
          var data = response.data
          this.listCommunicationType = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onCreateCommunication() {
      this.viewType = VIEW_FORM_COMMUNICATION
      this.viewMode = MODE_CREATE
      this.formCommunication.guestId = this.formData.id
      this.formCommunication.type = ''
      this.formCommunication.contactNo = ''
      this.formCommunication.note = ''
    },
    onDisplayCommunication(row) {
      this.viewType = VIEW_FORM_COMMUNICATION
      this.viewMode = MODE_VIEW

      this.formCommunication.id = row.id
      this.formCommunication.guestId = row.guestId
      this.formCommunication.type = row.type
      this.formCommunication.contactNo = row.contactNo
      this.formCommunication.note = row.note
    },
    onEditCommunication(row) {
      this.viewType = VIEW_FORM_COMMUNICATION
      this.viewMode = MODE_UPDATE

      this.formCommunication.id = row.id
      this.formCommunication.guestId = row.guestId
      this.formCommunication.type = row.type
      this.formCommunication.contactNo = row.contactNo
      this.formCommunication.note = row.note
    },
    onCancelCommunication() {
      if (this.viewMode === MODE_CREATE) {
        this.initForm()
      } else if (this.viewMode === MODE_UPDATE) {
        this.onDisplayCommunication(this.formCommunication)
      }
    },
    onBackCommunication() {
      this.initForm()
      this.viewType = VIEW_FORM_DETAIL
      this.viewMode = MODE_VIEW
      this.tabActive = TAB_COMMUNICATION
      this.onClickTabCommunication()
    },
    onSaveCommunication() {
      var reqData = {
        Id: this.formCommunication.id,
        GuestId: this.formCommunication.guestId,
        Type: this.formCommunication.type,
        ContactNo: this.formCommunication.contactNo,
        Note: this.formCommunication.note
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Guest', 'post', '/api/GuestCommunication/' + method, reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')

          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.viewMode = MODE_VIEW
            this.viewType = VIEW_FORM_COMMUNICATION
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onClickTabGroup() {
      api
        .request('Guest', 'get', '/api/Group/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listGroup = data.entity
        })
        .then(response => {
          api
            .request('Guest', 'get', '/api/GuestGroup/InquiryByGuestId?GuestId=' + this.formData.id, null)
            .then(response => {
              var data = response.data
              this.listGuestGroup = data.entity

              this.listGuestGroup.forEach(item => {
                var groupName = ''
                this.listGroup.some(function(itemGroup, index) {
                  if (item.groupId === itemGroup.id) {
                    groupName = itemGroup.name
                  }
                })
                item.groupName = groupName
              })
            })
            .catch(error => {
              var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
              SweetAlert.fire('Error', message, 'error')
            })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onDisplayGuestGroup(row) {
      this.viewType = VIEW_FORM_GROUP
      this.viewMode = MODE_VIEW

      this.formGuestGroup.id = row.id
      this.formGuestGroup.guestId = row.guestId
      this.formGuestGroup.type = row.type
      this.formGuestGroup.quota = row.quota
      this.formGuestGroup.company = row.company
      this.formGuestGroup.npwp = row.npwp
      this.formGuestGroup.address1 = row.address1
      this.formGuestGroup.address2 = row.address2
    },
    onCreateGroup() {
      this.viewType = VIEW_FORM_GROUP
      this.viewMode = MODE_CREATE
      this.formGuestGroup.guestId = this.formData.id
    },
    onClickTabGuestGroup() {
      // this.getAllGuest()
      api
        .request('Guest', 'get', '/api/GuestGroup/InquiryByGroupId?GroupId=' + this.formGroup.id, null)
        .then(response => {
          var data = response.data
          this.listGuestGroup = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onCancelGuestGroup() {
      if (this.viewMode === MODE_CREATE) {
        this.initForm()
      } else if (this.viewMode === MODE_UPDATE) {
        this.onDisplayGroup(this.formGuestGroup)
      }
    },
    onBackGuestGroup() {
      this.initForm()
      this.viewType = VIEW_FORM_DETAIL
      this.viewMode = MODE_VIEW
      this.tabActive = TAB_GROUP
      this.onClickTabGroup()
    },
    onSaveGuestGroup() {
      var data = {
        Id: this.formGuestGroup.id,
        Name: this.formGuestGroup.name,
        Type: this.formGuestGroup.type,
        Quota: this.formGuestGroup.quota,
        MainGuestId: this.formGuestGroup.guestId,
        Company: this.formGuestGroup.company,
        NPWP: this.formGuestGroup.npwp,
        Address1: this.formGuestGroup.address1,
        Address2: this.formGuestGroup.address2
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Guest', 'post', '/api/Group/' + method, data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity

          if (resData.returnStatus) {
            this.onDisplay({id: this.formData.id, name: this.formData.name})
          }

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onClickTabProperty() {
      api
        .request('Guest', 'get', '/api/GuestProperty/InquiryByGuestId?GuestId=' + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.listGuestProperty = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })

      api
        .request('Guest', 'get', '/api/GuestProperty/GetPropertyType', null)
        .then(response => {
          var data = response.data
          this.listPropertyType = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onCreateProperty() {
      this.viewType = VIEW_FORM_PROPERTY
      this.viewMode = MODE_CREATE
      this.formProperty.guestId = this.formData.id
      this.formProperty.type = ''
      this.formProperty.name = ''
      this.formProperty.cluster = ''
      this.formProperty.block = ''
      this.formProperty.number = ''
      this.formProperty.tower = ''
      this.formProperty.floor = ''
      this.formProperty.note = ''
    },
    onDisplayProperty(row) {
      this.viewType = VIEW_FORM_PROPERTY
      this.viewMode = MODE_VIEW

      this.formProperty.id = row.id
      this.formProperty.guestId = row.guestId
      this.formProperty.type = row.type
      this.formProperty.name = row.name
      this.formProperty.cluster = row.cluster
      this.formProperty.block = row.block
      this.formProperty.number = row.number
      this.formProperty.tower = row.tower
      this.formProperty.floor = row.floor
      this.formProperty.note = row.note
    },
    onEditProperty(row) {
      this.viewType = VIEW_FORM_PROPERTY
      this.viewMode = MODE_UPDATE

      this.formProperty.id = row.id
      this.formProperty.guestId = row.guestId
      this.formProperty.type = row.type
      this.formProperty.name = row.name
      this.formProperty.cluster = row.cluster
      this.formProperty.block = row.block
      this.formProperty.number = row.number
      this.formProperty.tower = row.tower
      this.formProperty.floor = row.floor
      this.formProperty.note = row.note
    },
    onCancelProperty() {
      if (this.viewMode === MODE_CREATE) {
        this.initForm()
      } else if (this.viewMode === MODE_UPDATE) {
        this.onDisplayProperty(this.formProperty)
      }
    },
    onBackProperty() {
      this.initForm()
      this.viewType = VIEW_FORM_DETAIL
      this.viewMode = MODE_VIEW
      this.tabActive = TAB_PROPERTY
      this.onClickTabProperty()
    },
    onSaveProperty() {
      var reqData = {
        Id: this.formProperty.id,
        GuestId: this.formProperty.guestId,
        Type: this.formProperty.type,
        Name: this.formProperty.name,
        Cluster: this.formProperty.cluster,
        Block: this.formProperty.block,
        Number: this.formProperty.number,
        Tower: this.formProperty.tower,
        Floor: this.formProperty.floor,
        Note: this.formProperty.note
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Guest', 'post', '/api/GuestProperty/' + method, reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')

          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.viewMode = MODE_VIEW
            this.viewType = VIEW_FORM_PROPERTY
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onClickTabActivity() {
      api
        .request('Account', 'get', '/api/Project/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listProject = data.entity
        })
        .then(response => {
          api
            .request('Guest', 'get', '/api/GuestActivity/InquiryByGuestId?GuestId=' + this.formData.id, null)
            .then(response => {
              var data = response.data
              this.listGuestActivity = data.entity

              this.listGuestActivity.forEach(item => {
                var projectName = ''
                this.listProject.some(function(itemProject, index) {
                  if (item.projectId === itemProject.id) {
                    projectName = itemProject.name
                  }
                })
                item.projectName = projectName
              })
            })
            .catch(error => {
              var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
              SweetAlert.fire('Error', message, 'error')
            })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getPaymentImage(id) {
      SweetAlert.fire({
        title: '',
        html: '<img src="' + this.getPaymentImageUrl(id) + '" class="img-responsive img-thumbnail">',
        // type: 'info',
        showCancelButton: false,
        // confirmButtonText: 'Continue',
        // cancelButtonText: 'Cancel',
        // showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
      })
    },
    onCreateDocument() {
      this.viewType = VIEW_FORM_DOCUMENT
      this.viewMode = MODE_CREATE
      this.formDocument.guestId = this.formData.id
      this.formDocument.name = ''
      this.formDocument.imageUrl = ''
      this.formDocument.picture = null
    },
    onDisplayDocument(row) {
      this.viewType = VIEW_FORM_DOCUMENT
      this.viewMode = MODE_VIEW
      this.formDocument.id = row.id
      this.formDocument.guestId = row.guestId
      this.formDocument.name = row.name
      this.formDocument.imageUrl = row.imageUrl
    },
    onEditDocument(row) {
      this.viewType = VIEW_FORM_DOCUMENT
      this.viewMode = MODE_UPDATE
      this.formDocument.id = row.id
      this.formDocument.guestId = row.guestId
      this.formDocument.name = row.name
      this.formDocument.imageUrl = row.imageUrl
    },
    onCancelDocument() {
      if (this.viewMode === MODE_CREATE) {
        this.initForm()
      } else if (this.viewMode === MODE_UPDATE) {
        this.onDisplayDocument(this.formDocument)
      }
    },
    onBackDocument() {
      this.initForm()
      this.viewType = VIEW_FORM_DETAIL
      this.viewMode = MODE_VIEW
      this.tabActive = TAB_DOCUMENT
      this.onClickTabDocument()
    },
    onSaveDocument() {
      var reqData = {
        Id: this.formDocument.id,
        GuestId: this.formDocument.guestId,
        Name: this.formDocument.name,
        ImageUrl: this.formDocument.imageUrl,
        ImageBase64String: this.formDocument.picture
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Guest', 'post', '/api/GuestDocument/' + method, reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')

          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.viewMode = MODE_VIEW
            this.viewType = VIEW_FORM_DOCUMENT
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onConfirmationDeleteDocument(row) {
      SweetAlert.fire({
        title: 'Are you sure ?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continue',
        cancelButtonText: 'Cancel',
        showCloseButton: true
        // showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.DeleteDocument(row)
          SweetAlert.fire('Deleting guest document', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          SweetAlert.fire('Deleting guest document', 'You are cancel this process ', 'info')
        }
      })
    },
    onDeleteDocument(row) {
      this.onConfirmationDeleteDocument(row)
    },
    DeleteDocument(row) {
      var reqData = {
        Id: row.id,
        GuestId: row.guestId,
        Name: row.name
      }

      var status = 'success'
      var message = ''

      api
        .request('Guest', 'post', '/api/GuestDocument/Delete', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')

          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.onClickTabDocument()
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getDocumentImage(id) {
      SweetAlert.fire({
        title: '',
        html: '<img src="' + this.getDocumentImageUrl(id) + '" class="img-responsive img-thumbnail">',
        // type: 'info',
        showCancelButton: false,
        // confirmButtonText: 'Continue',
        // cancelButtonText: 'Cancel',
        // showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
      })
    },
    onLeaveMembership(row) {
      this.formLeave.guestId = this.formData.id
      this.formLeave.guestName = this.formData.firstName + ' ' + this.formData.lastName
      this.formLeave.membershipId = row.membershipId
      this.formLeave.membershipName = row.membershipName
      this.formLeave.projectId = row.projectId

      this.formLeave.dateFrom = ''
      this.showDateFrom = false
      this.$nextTick(() => {
        this.showDateFrom = true
      })

      this.formLeave.dateTo = ''
      this.showDateTo = false
      this.$nextTick(() => {
        this.showDateTo = true
      })

      window.$('#modal-create-leave').modal('show')
    },
    onContinueCreateLeave() {
      var reqData = {
        GuestId: this.formLeave.guestId,
        MembershipId: this.formLeave.membershipId,
        ProjectId: this.formLeave.projectId,
        DateFrom: $('#dateFrom').val(),
        DateTo: $('#dateTo').val(),
        Description: this.formLeave.description
      }

      var status = 'success'
      var message = ''

      api
        .request('Guest', 'post', '/api/Guest/Leave', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')

          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.onClickTabMembership()
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onClickTabLeave() {
      api
        .request('Guest', 'get', '/api/Guest/Leave?WhereClause=GuestId=' + this.formData.id + '&PageSize=999999&CurrentPageNumber=1&SortDirection=DESC&SortExpression=DateFrom', null)
        .then(response => {
          var resData = response.data
          this.listLeave = resData.entity
        })
        .then(response => {
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  width: 250px;
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

.icheckbox_flat-green,
.iradio_flat-green {
    display: inline-block;
    /* display: inline; */
    vertical-align: middle;
    margin: 0;
    padding: 0;
    width: 20px;
    height: 20px;
    background: url('/static/img/green.png') no-repeat;
    border: none;
    cursor: pointer;
}

.icheckbox_flat-green {
    background-position: 0 0;
}
    .icheckbox_flat-green.checked {
        background-position: -22px 0;
    }
    .icheckbox_flat-green.disabled {
        background-position: -44px 0;
        cursor: default;
    }
    .icheckbox_flat-green.checked.disabled {
        background-position: -66px 0;
    }

.iradio_flat-green {
    background-position: -88px 0;
}
    .iradio_flat-green.checked {
        background-position: -110px 0;
    }
    .iradio_flat-green.disabled {
        background-position: -132px 0;
        cursor: default;
    }
    .iradio_flat-green.checked.disabled {
        background-position: -154px 0;
    }

.datetime-picker input {
  height: 34px !important;
}


.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// GuestForm.vue?5346a0c6